"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BackgroundDescriptionEnum;
(function (BackgroundDescriptionEnum) {
    // Default initial assets
    BackgroundDescriptionEnum["LOGIN"] = "Branded pattern background";
    BackgroundDescriptionEnum["OCEAN"] = "Photo of an ocean with fishes";
    BackgroundDescriptionEnum["WAVES"] = "Photo of an ocean wave breaking with tunnel";
    BackgroundDescriptionEnum["PURPLE_PINWHEEL"] = "Branded pattern background";
    // K-5
    BackgroundDescriptionEnum["DARK_GALAXY"] = "Cartoon blue space image with planets";
    BackgroundDescriptionEnum["SUNNY_GALAXY"] = "Cartoon green space image with Sun, meteors, and stars";
    BackgroundDescriptionEnum["SUNSPOT_GALAXY"] = "Cartoon image of burgundy space scene with planets";
    BackgroundDescriptionEnum["SUNSET"] = "Cartoon image of a sunset and hills";
    BackgroundDescriptionEnum["BLUE_SKY"] = "Cartoon image of sky with clouds and the sun";
    BackgroundDescriptionEnum["DESERT"] = "Cartoon image of a desert with cactuses";
    BackgroundDescriptionEnum["BLUE_SEA"] = "Cartoon image of underwater scenery";
    BackgroundDescriptionEnum["DEEP_DIVE"] = "Cartoon image of deep sea with underwater scenery";
    BackgroundDescriptionEnum["SUNSET_HILLS"] = "Cartoon image with rolling hills and sunset";
    BackgroundDescriptionEnum["HAPPY_HILLS"] = "Cartoon image with rolling hills and blue sky";
    BackgroundDescriptionEnum["FOREST"] = "Cartoon image with rolling hills and blue sky";
    BackgroundDescriptionEnum["SPACE_ODYSSEY"] = "Illustration of green space scene.";
    BackgroundDescriptionEnum["MOUNTAINSK5"] = "Illustration of tall mountains with sky background.";
    BackgroundDescriptionEnum["CRIMSON_SPACE"] = "Illustration of red space scene.";
    BackgroundDescriptionEnum["SPACE_DESERT"] = "Illustration of wrecked spaceship in desert space scene.";
    BackgroundDescriptionEnum["WATERFALLS"] = "Illustration of night scene with mountains and waterfall.";
    BackgroundDescriptionEnum["MOUNTAINSIDE"] = "Illustration of rolling hills with mountains in the distance.";
    BackgroundDescriptionEnum["DESERT_FLOWER"] = "Illustration of desert scene with cacti flowers.";
    BackgroundDescriptionEnum["MOUNTAIN_LAKE"] = "Illustration of lake and mountains.";
    BackgroundDescriptionEnum["NIGHT_SKY"] = "Illustration of night sky with many clouds and stars.";
    BackgroundDescriptionEnum["SEA_PLANTS"] = "Illustration of underwater sea plants and coral.";
    // 6-8
    BackgroundDescriptionEnum["MOUNTAIN_FALLS"] = "Image of mountains with a water fall";
    BackgroundDescriptionEnum["COSMOS"] = "Cosmic space background";
    BackgroundDescriptionEnum["WAVE"] = "Photo of an ocean wave";
    BackgroundDescriptionEnum["CACTI"] = "Illustration of various cacti on a pink background";
    BackgroundDescriptionEnum["WATER"] = "Underwater view";
    BackgroundDescriptionEnum["JELLYFISH"] = "Underwater jellyfish with pink hues";
    BackgroundDescriptionEnum["PINK_PATTERN"] = "Pink Pattern";
    BackgroundDescriptionEnum["DOG"] = "Profile of a dog on aqua background";
    BackgroundDescriptionEnum["PANDA"] = "Illustration of Panda on aqua background";
    BackgroundDescriptionEnum["COOL_CAT"] = "Photo of a cat with sunglasses on";
    BackgroundDescriptionEnum["HAPPY_PUPPY68"] = "Photo of excited puppy.";
    BackgroundDescriptionEnum["AMUSEMENT"] = "Photo of ferris wheel and roller coaster.";
    BackgroundDescriptionEnum["SPACE_KITTY"] = "Photo of kitten in spacesuit in space.";
    BackgroundDescriptionEnum["THINKING_MONKEY"] = "Illustration of monkey wearing headphones.";
    BackgroundDescriptionEnum["FISH_PARTY"] = "Photo of clown fish in anemones.";
    // 9-12
    BackgroundDescriptionEnum["PURPLE_PATTERN"] = "Purple Pattern";
    BackgroundDescriptionEnum["BIG_WAVE"] = "Photo of a big wave";
    BackgroundDescriptionEnum["BRIGHT_SWATCHES"] = "Illustration of bright paint swatches on canvas";
    BackgroundDescriptionEnum["DEEP_SPACE"] = "Photo of a cosmic space scene";
    BackgroundDescriptionEnum["HAPPY_PUPPY"] = "Photo of puppy running";
    BackgroundDescriptionEnum["LEAVES"] = "Illustration of green leaves";
    BackgroundDescriptionEnum["NAP_TIME"] = "Photo of a puppy and kitten taking a nap together";
    BackgroundDescriptionEnum["SPACE_LIGHT"] = "Photo of space scene with bright light";
    BackgroundDescriptionEnum["SUNNY_STREAM"] = "Photo of a stream in the woods with sunrise";
    BackgroundDescriptionEnum["WATERFALL"] = "Illustration of scenic mountains with a sunset and waterfall";
    BackgroundDescriptionEnum["MOUNTAINS"] = "Photo of a mountain scene on coast";
    BackgroundDescriptionEnum["SEA_CORAL"] = "Photo of sea coral.";
    BackgroundDescriptionEnum["DESERT_SUNSET"] = "Photo of desert sunset.";
    BackgroundDescriptionEnum["TROPICS"] = "Photo of tropical landscape.";
    BackgroundDescriptionEnum["MACHU_PICCHU"] = "Photo of Machu Picchu.";
    BackgroundDescriptionEnum["PYRAMIDS"] = "Photo of pyramids in the desert.";
    BackgroundDescriptionEnum["SPIDER_WEB"] = "Photo of spider web.";
    BackgroundDescriptionEnum["ANCIENT_RUINS"] = "Photo of ancient ruins.";
    BackgroundDescriptionEnum["HORSESHOE_BEND"] = "Photo of Horseshoe Bend.";
    BackgroundDescriptionEnum["WHALE_SUNSET"] = "Photo of swimming whale.";
    // AMUSEMENT shared from 6-8
    // Visual Action Backgrounds
    BackgroundDescriptionEnum["ENGLISH"] = "English";
    BackgroundDescriptionEnum["READING"] = "Reading";
    BackgroundDescriptionEnum["MATH"] = "Math";
    // Theme specific
    BackgroundDescriptionEnum["DEFAULT"] = "default";
    BackgroundDescriptionEnum["PRIMARY"] = "primary";
})(BackgroundDescriptionEnum || (BackgroundDescriptionEnum = {}));
exports.default = BackgroundDescriptionEnum;
